export class ReabrirNotaFiscalEntradaDialogData {
  numeroNota = '';
}
